﻿import {translation} from "@2d-front-monorepo/core";
import {LinkButton} from "@2d-front-monorepo/design-library";
import {JSX} from "react";
import {Navigate} from "react-router";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useUser} from "../hooks/useUser";

import {PrivateRoutes, PublicRoutes} from "../routes";
import { marked } from "marked";

export default function WelcomePage(): JSX.Element {
	const user = useUser();
	if (user.authStatus == "logged-in") {
		return (<Navigate to={PrivateRoutes.permitsHome}></Navigate>)
	}

	return (
		<section className="welcome full-layout full-layout--centered">
			<h1>{translation(PermitTranslations.welcome_page__title)}</h1>

			<div dangerouslySetInnerHTML={{__html: marked(translation(PermitTranslations.welcome_page__body))}}></div>

			<div className="layout vertical gap">
				<LinkButton to={PublicRoutes.signIn} kind="primary" autoFocus>{translation(PermitTranslations.sign_in)}</LinkButton>
				<small style={{textAlign: "center"}}>{translation(PermitTranslations.welcome_page__or)}</small>
				<LinkButton to={PublicRoutes.signUp}>{translation(PermitTranslations.sign_up)}</LinkButton>
			</div>
			<p><small dangerouslySetInnerHTML={{__html: marked(translation(PermitTranslations.website__terms_and_conditions))}}></small></p>
		</section>
	);
}
